import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useTheme, ThemeButton } from './theme';
import { usePolling } from './poll';

// TM RUSH Comando: what each robot does, hour by hour, whether each run worked, and what is waiting for Maurício.
// Access: open /comando#k=<key> once; the key stays in this browser. Internal page, in Portuguese.
const API = 'https://n8n-hag0.srv1897462.hstgr.cloud/webhook';
const KEY_STORE = 'tmr_cmd_key';

const readKey = () => {
  try {
    const m = window.location.hash.match(/k=([A-Za-z0-9_-]+)/);
    if (m) {
      try { localStorage.setItem(KEY_STORE, m[1]); } catch (e) { /* storage blocked */ }
      window.history.replaceState(null, '', window.location.pathname);
      return m[1];
    }
    return localStorage.getItem(KEY_STORE) || '';
  } catch (e) {
    return '';
  }
};

const ROBOTS = [
  { id: 'lia', name: 'Lia', color: '#53c46c', area: 'Pedidos', status: 'live', when: 'Na hora, 24 h', what: 'Pagamento confirmado → abre a área do cliente, gera a procuração e avisa a Belle e a Carol.', you: 'Nada. Sai sozinho.', runs: [{ always: true, text: 'Atende pedido novo na hora', unit: ['pedido', 'pedidos'] }] },
  { id: 'nico', name: 'Nico', color: '#9b8cff', area: 'Financeiro', status: 'live', when: 'Na hora', what: 'Pedido de invoice pelo site → monta o rascunho com os dados bancários exatos. Quando você aprova, a invoice sai e a área do cliente abre; o comprovante da transferência libera o processo.', you: 'Aprovar cada invoice.', runs: [{ always: true, text: 'Invoice pedida no site → sua aprovação', unit: ['invoice', 'invoices'] }] },
  { id: 'sol', name: 'Sol', color: '#9aa5a0', area: 'Sistema', status: 'live', when: 'Todo dia 07:00', what: 'Confere se todos os robôs rodaram e se algo falhou. Só manda e-mail quando tem problema.', you: 'Só quando algo quebrar.', runs: [{ days: [0, 1, 2, 3, 4, 5, 6], time: '07:00', text: 'Confere se os robôs rodaram e avisa se algo falhou' }] },
  { id: 'scout', name: 'Grok · Scout', grok: true, color: '#e8c547', area: 'Leads', status: 'live', when: 'Todo dia 07:30', what: 'Varre o X e as notícias atrás de empresas estrangeiras anunciando chegada ao Brasil ou à América Latina, e de escritórios de PI falando de Brasil.', you: 'Nada. Vira lead para o Pedro e pauta para o Max.', runs: [{ days: [0, 1, 2, 3, 4, 5, 6], time: '07:30', text: 'Empresas estrangeiras chegando ao Brasil → leads' }] },
  { id: 'lens', name: 'Grok · Lens', grok: true, color: '#e8c547', area: 'INPI', status: 'future', when: 'Segunda 07:00', what: 'Notícias do INPI e de PI no mundo: mudança de taxa, feriado, atraso da RPI, sistema fora do ar.', you: 'Nada. Avisa só se mudar algo que afeta prazo ou preço.', runs: [{ days: [1], time: '07:00', text: 'Notícias do INPI (taxas, feriados, atraso da RPI)' }] },
  { id: 'theo', name: 'Theo', color: '#4aa3ff', area: 'LinkedIn', status: 'live', when: 'Seg a sáb 08:27 e 10:27; ter a qui também 12:07, 14:07, 22:07', what: 'Publica os posts aprovados no seu perfil e na página, acha comentários novos, publica as respostas aprovadas e, de segunda a sexta, convida conexões suas para seguir a página TM RUSH (créditos grátis do LinkedIn).', you: 'Aprovar posts e respostas aqui no Comando (seção LinkedIn).', runs: [{ days: [1, 2, 3, 4, 5, 6], time: '08:27', text: 'LinkedIn: publica o aprovado e acha comentários novos' }, { days: [1, 2, 3, 4, 5, 6], time: '10:27', text: 'LinkedIn: confere o post das 10h, lê as métricas e convida conexões para seguir a página' }, { days: [2, 3, 4], time: '12:07', text: 'LinkedIn: comentários do post do dia' }, { days: [2, 3, 4], time: '14:07', text: 'LinkedIn: comentários do post do dia' }, { days: [2, 3, 4], time: '22:07', text: 'LinkedIn: última varredura de comentários' }] },
  { id: 'vera', name: 'Vera', color: '#36c2b4', area: 'Aprovações', status: 'live', when: 'Seg a sex 08:30', what: 'Lembra o que está esperando sua aprovação (avisos do Watch, invoices) e envia na hora o que você aprovar.', you: 'Aprovar os avisos aos clientes.', runs: [{ days: [1, 2, 3, 4, 5], time: '08:30', text: 'Lembrete do que espera sua aprovação' }] },
  { id: 'pedro', name: 'Pedro', color: '#ff8a4c', area: 'Prospecção', status: 'live', when: 'Todo dia 09:00 (envio); terça 10:07 e 15:07 (garimpo, repete até sexta se a RPI atrasar)', what: 'Terça: garimpa a RPI (estrangeiros sem procurador no Brasil), confere o advogado no USPTO e monta o lote sniper no Desk. Todo dia 9h: envia o que você aprovou, um a um.', you: 'Aprovar o lote da semana no Desk (um clique).', runs: [{ days: [0, 1, 2, 3, 4, 5, 6], time: '09:00', text: 'Envia os e-mails de prospecção aprovados para hoje (um a cada 30 s)' }, { days: [2], time: '15:00', text: 'Garimpo da RPI: lote sniper da semana no calendário (sua aprovação)', statusKey: 'pedro_garimpo', status: 'new' }] },
  { id: 'max', name: 'Max', color: '#5b7cff', area: 'Autoridade', status: 'live', when: 'Seg a sex 09:17 e 16:17', what: 'Acha posts de referência em PI fora do Brasil e propõe um comentário sniper seu; publica o que você aprovar.', you: 'Aprovar os comentários aqui no Comando (seção LinkedIn).', runs: [{ days: [1, 2, 3, 4, 5], time: '09:17', text: 'Radar LinkedIn: propõe comentários sniper (sua aprovação)' }, { days: [1, 2, 3, 4, 5], time: '16:17', text: 'Radar LinkedIn: segunda rodada' }] },
  { id: 'rita', name: 'Rita', color: '#2fd17a', area: 'RPI', status: 'live', when: 'De hora em hora até baixar a RPI de terça', what: 'Tenta baixar a RPI do INPI de hora em hora até conseguir (o site do INPI oscila), lê os despachos de cada marca vigiada, lê os despachos de cada marca vigiada, atualiza a régua de prazos e prepara os avisos do Watch.', you: 'Aprovar os avisos aos clientes.', runs: [{ days: [2], time: '09:00', text: 'RPI da semana: tenta de hora em hora até baixar e lê os despachos das marcas vigiadas' }] },
  { id: 'cris', name: 'Cris', color: '#7fd1ff', area: 'Financeiro', status: 'live', when: 'Na hora (cada GRU paga) e dia 1º às 08:00', what: 'Controla o financeiro: o que os clientes pagaram, cada GRU paga com o comprovante, GRUs a pagar e notas fiscais a emitir. No dia 1º manda o resumo do mês.', you: 'Nada. Só ler o resumo do mês.', runs: [{ always: true, text: 'Registra cada GRU paga com o comprovante', unit: ['GRU paga', 'GRUs pagas'] }, { monthDay: 1, time: '08:00', text: 'Resumo financeiro do mês para você' }] },
  { id: 'ivo', name: 'Ivo', color: '#c77dff', area: 'Pedidos', status: 'live', when: 'Todo dia 10:00', what: 'Revisa cada pedido aberto: comprovante da transferência, titular, marca, logo, produtos e serviços, procuração. Lembra o cliente no 2º, 4º e 9º dia e depois toda semana até completar. No 4º lembrete sem resposta, avisa a equipe para um contato pessoal. Avisa também quando o pedido está pronto para protocolar.', you: 'Nada. Lembretes ao cliente saem sozinhos.', runs: [{ days: [0, 1, 2, 3, 4, 5, 6], time: '10:00', text: 'Revisa os pedidos abertos e lembra o cliente do que falta' }] },
  { id: 'bia', name: 'Bia', color: '#ff6fa8', area: 'Prospecção', status: 'new', when: 'Seg a sex 11:00', what: 'Prepara o segundo contato para quem não respondeu em 7 dias, no mesmo fio do e-mail.', you: 'Aprovar o lote de follow-ups.', runs: [{ days: [1, 2, 3, 4, 5], time: '11:00', text: 'Follow-up D+7 para quem não respondeu (sua aprovação)' }] },
  { id: 'duda', name: 'Duda', color: '#ffb84d', area: 'Caixa de entrada', status: 'new', when: 'Seg a sex 12:00 e 17:00', what: 'Lê as respostas, devoluções e respostas automáticas no Zoho, marca no Desk e rascunha a resposta (recusa educada ganha um agradecimento). Ausência com data de volta vira follow-up 2 dias úteis depois da volta; se a resposta automática indicar outra pessoa, prepara o reenvio. Tudo aparece no calendário para você aprovar.', you: 'Aprovar no calendário.', runs: [{ days: [1, 2, 3, 4, 5], time: '12:00', text: 'Lê respostas e devoluções no Zoho e marca no Desk' }, { days: [1, 2, 3, 4, 5], time: '17:00', text: 'Segunda leitura da caixa; rascunha respostas (sua aprovação)' }] },
  { id: 'caio', name: 'Caio', color: '#ff5d5d', area: 'Colidências', status: 'future', when: 'Terça 19:00', what: 'Depois da RPI, compara as marcas dos clientes com as publicadas na semana e prepara um alerta informativo (nunca recomenda opor).', you: 'Aprovar cada alerta antes de sair.', runs: [{ days: [2], time: '19:00', text: 'Compara as marcas dos clientes com as publicadas (alertas para sua aprovação)' }] },
];
const BY_ID = Object.fromEntries(ROBOTS.map((r) => [r.id, r]));

const STATUS_LABEL = { live: 'No ar', new: 'Fase 2', future: 'Fase 3' };
const STATUS_TONE = { live: 'bg-[#53c46c]/15 text-[#7ee08f]', new: 'bg-[#e8c547]/15 text-[#f1d36b]', future: 'bg-white/10 text-gray-300' };
const TONE = { red: '#ff6b6b', green: '#53c46c', blue: '#4aa3ff', gold: '#e8c547' };
const DOW = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];
const H = 36e5;
const MIN = 6e4;

// Brasília has no daylight saving time: local time = UTC - 3 h.
const spYmd = (t) => new Date(t - 3 * H).toISOString().slice(0, 10);
const slotAt = (ymd, time) => Date.parse(`${ymd}T${time}:00-03:00`);
const ms = (s) => { const t = Date.parse(s || ''); return Number.isNaN(t) ? 0 : t; };
const hhmm = (s) => new Date(ms(s) - 3 * H).toISOString().slice(11, 16);
const ddmm = (s) => { const d = new Date(ms(s) - 3 * H).toISOString(); return `${d.slice(8, 10)}/${d.slice(5, 7)}`; };
const when = (s) => (spYmd(ms(s)) === spYmd(Date.now()) ? `hoje ${hhmm(s)}` : `${ddmm(s)} ${hhmm(s)}`);
const plural = (n, [one, many]) => `${n} ${n === 1 ? one : many}`;

const statusOf = (robot, run, data) => {
  const st = (data && data.status) || {};
  if (run && run.statusKey) return st[run.statusKey] || run.status || robot.status;
  return st[robot.id] || robot.status;
};

const buildWeek = (data, now) => {
  const runs = (data && data.runs) || [];
  const since = ms((data && data.log_since) || '') || Infinity;
  const days = [];
  for (let i = -1; i <= 6; i += 1) {
    const ymd = spYmd(now + i * 24 * H);
    const dow = new Date(`${ymd}T12:00:00Z`).getUTCDay();
    const items = [];
    ROBOTS.forEach((r) => r.runs.forEach((run) => {
      const status = statusOf(r, run, data);
      if (run.always) items.push({ robot: r, run, always: true, time: 'sempre', sort: -1, text: run.text, status, slot: 0, hits: [] });
      else if (run.monthDay ? Number(ymd.slice(8, 10)) === run.monthDay : run.days.includes(dow)) items.push({ robot: r, run, time: run.time, sort: Number(run.time.replace(':', '')), text: run.text, status, slot: slotAt(ymd, run.time), hits: [] });
    }));
    items.sort((a, b) => a.sort - b.sort);
    const label = i === 0 ? 'Hoje' : i === 1 ? 'Amanhã' : i === -1 ? 'Ontem' : DOW[dow];
    days.push({ ymd, i, label, date: `${ymd.slice(8, 10)}/${ymd.slice(5, 7)}`, items, today: i === 0 });
  }
  // each run goes to the latest slot of the same robot that started before it (20 min of slack)
  const slots = days.flatMap((d) => d.items.filter((x) => !x.always));
  const free = [];
  for (const r of runs) {
    const t = ms(r.at);
    if (r.event) {
      const d = days.find((x) => x.ymd === spYmd(t));
      const it = d && d.items.find((x) => x.always && x.robot.id === r.robot);
      if (it) it.hits.push(r);
      continue;
    }
    let best = null;
    for (const s of slots) if (s.robot.id === r.robot && s.slot - 20 * MIN <= t && t - s.slot < 6 * H && (!best || s.slot > best.slot)) best = s;
    if (!best) {
      // run before the robot's first slot of that day (e.g. the RPI downloaded at dawn): count it for that slot
      const same = slots.filter((s) => s.robot.id === r.robot && spYmd(s.slot) === spYmd(t)).sort((a, b) => a.slot - b.slot);
      if (same.length && t < same[0].slot) best = same[0];
    }
    if (best) best.hits.push(r); else free.push(r);
  }
  for (const d of days) for (const it of d.items) {
    if (it.always) {
      const past = d.i <= 0;
      it.state = it.hits.some((x) => !x.ok) ? 'fail' : (past && it.hits.length ? 'ok' : 'none');
      it.note = past && d.i <= 0 ? (it.hits.length ? plural(it.hits.length, it.run.unit) : (d.i === 0 ? 'nada ainda hoje' : 'nenhum')) : '';
      continue;
    }
    const last = it.hits.slice().sort((a, b) => ms(b.at) - ms(a.at))[0];
    if (last) { it.state = it.hits.some((x) => !x.ok) ? 'fail' : 'ok'; it.last = it.hits.find((x) => !x.ok) || last; }
    else if (it.slot > now) it.state = 'next';
    else if (it.slot < since || it.status !== 'live') it.state = 'old';
    else if (now - it.slot < 150 * MIN) it.state = 'running';
    else it.state = 'missed';
  }
  return { days, free };
};

const ICON = { ok: '✅', fail: '❌', missed: '⚠️', running: '⏳' };

const Bar = ({ color }) => <span className="w-1 self-stretch rounded-full shrink-0" style={{ background: color }} />;
const Pill = ({ status }) => <span className={`ml-1.5 text-[10px] font-semibold rounded px-1 py-0.5 align-middle ${STATUS_TONE[status]}`}>{STATUS_LABEL[status]}</span>;
const GrokTag = () => <span className="ml-1.5 text-[10px] font-bold bg-[#e8c547]/20 text-[#f1d36b] rounded px-1 py-0.5 align-middle">GROK</span>;

const Task = ({ it, dim }) => {
  const [open, setOpen] = useState(false);
  const clickable = it.state === 'fail' || it.state === 'missed' || (it.last && it.last.resumo);
  const border = it.state === 'fail' ? 'border-[#ff6b6b]/60' : it.state === 'missed' ? 'border-[#e8c547]/50' : 'border-transparent';
  return (
    <button type="button" onClick={() => clickable && setOpen(!open)} className={`w-full text-left flex gap-3 rounded-xl px-3 py-2.5 border ${border} ${dim ? 'bg-white/[0.03]' : 'bg-white/[0.06]'} ${clickable ? 'cursor-pointer' : 'cursor-default'}`}>
      <Bar color={it.robot.color} />
      <div className="w-11 shrink-0 text-[11px] text-gray-400 pt-0.5 leading-tight">
        {it.time}
        {ICON[it.state] && <div className="text-[13px] mt-1">{ICON[it.state]}</div>}
      </div>
      <div className={`min-w-0 text-[13px] leading-snug ${dim && it.state === 'old' ? 'opacity-50' : ''}`}>
        <span className="font-semibold text-white">{it.robot.name}</span>
        {it.robot.grok && <GrokTag />}
        <span className="text-gray-300"> · {it.text}</span>
        {it.status !== 'live' && <Pill status={it.status} />}
        {it.note && <div className="text-[11px] text-gray-400 mt-1">{it.note}</div>}
        {it.state === 'running' && <div className="text-[11px] text-gray-400 mt-1">rodando agora…</div>}
        {it.state === 'missed' && <div className="text-[11px] text-[#f1d36b] mt-1">não registrou esta rodada{open ? ' (o Sol avisa no e-mail das 7h se continuar)' : ''}</div>}
        {it.last && (it.state === 'ok' || open) && it.last.resumo && <div className="text-[11px] text-gray-400 mt-1">{hhmm(it.last.at)} · {it.last.resumo}</div>}
        {it.state === 'fail' && <div className="text-[11px] text-[#ff9b9b] mt-1">{open ? (it.last.motivo || it.last.resumo) : 'falhou · toque para ver o motivo'}</div>}
      </div>
    </button>
  );
};

// e-mails que os robôs deixam prontos: aparecem no dia em que saem, com Aprovar e Descartar
const STATE_TXT = { approved: 'aprovado', sent: 'enviado' };
const AgendaCard = ({ g, today, onDecide }) => {
  // e-mail esperando aprovação já aparece aberto, para ler e aprovar sem clicar antes
  const [open, setOpen] = useState(g.state === 'pending' && g.count > 1 && g.count <= 12);
  const [show, setShow] = useState(g.state === 'pending' && g.count === 1 && g.items[0] && g.items[0].body ? g.items[0].id : '');
  const [arm, setArm] = useState('');
  const [busy, setBusy] = useState(false);
  const inFlight = useRef(false);
  const robot = BY_ID[g.robot] || { name: g.robot, color: '#9aa5a0' };
  const single = g.count === 1 ? g.items[0] : null;
  const future = g.day > today;
  // aprovar e desfazer: um clique só; descartar (apaga o rascunho) ainda pede confirmação.
  // inFlight segura cliques repetidos antes da tela atualizar; o servidor também ignora o que já foi aprovado.
  const act = async (a, ids) => {
    if (inFlight.current) return;
    if (a === 'discard' && arm !== a + ids.join(',')) { setArm(a + ids.join(',')); setTimeout(() => setArm(''), 5000); return; }
    inFlight.current = true;
    setArm('');
    setBusy(true);
    try { await onDecide(a, ids); } finally { setBusy(false); inFlight.current = false; }
  };
  const label = (a, ids, text) => (arm === a + ids.join(',') && a === 'discard' ? 'Descartar mesmo?' : text);
  const ids = g.items.map((x) => x.id);
  const time = g.state === 'sent' ? '✓' : future || g.state === 'approved' ? '9h' : 'agora';
  const border = g.state === 'pending' ? 'border-[#53c46c]/70' : 'border-transparent';
  return (
    <div className={`rounded-xl px-3 py-2.5 border ${border} ${g.state === 'pending' ? 'bg-[#53c46c]/[0.08]' : 'bg-white/[0.04]'}`}>
      <div className="flex gap-3">
        <Bar color={robot.color} />
        <div className="w-11 shrink-0 text-[11px] text-gray-400 pt-0.5 leading-tight">{time}</div>
        <div className="min-w-0 flex-1 text-[13px] leading-snug">
          <div>
            <span className="font-semibold text-white">{robot.name}</span>
            <span className="text-gray-300"> · {g.label}</span>
            {g.state !== 'pending' && <span className="ml-1.5 text-[10px] font-semibold rounded px-1 py-0.5 bg-[#53c46c]/15 text-[#7ee08f]">{STATE_TXT[g.state]}</span>}
            {g.late && <span className="ml-1.5 text-[10px] font-semibold rounded px-1 py-0.5 bg-[#e8c547]/15 text-[#f1d36b]">atrasado</span>}
          </div>
          {single ? (
            <div className="mt-1">
              <div className="text-white/90 truncate">{single.to}{single.review && g.state === 'pending' ? <span className="text-[#ff9b9b]"> · revisar</span> : null}</div>
              <div className="text-[11px] text-gray-400 truncate">{single.subject}</div>
              {single.cc && <div className="text-[11px] text-gray-500 truncate">cc {single.cc}</div>}
            </div>
          ) : (
            <button type="button" onClick={() => setOpen(!open)} className="mt-1 text-[12px] text-gray-300 hover:text-white">{g.count} e-mails {open ? '▴' : '▾'}</button>
          )}
          {g.state === 'sent' && single && single.sent_at && <div className="text-[11px] text-gray-400 mt-1">enviado às {hhmm(single.sent_at)}</div>}
          {g.state === 'approved' && <div className="text-[11px] text-gray-400 mt-1">sai {g.day === today ? 'hoje' : `em ${g.day.slice(8, 10)}/${g.day.slice(5, 7)}`} às 9h, de mauricio.reis@tmrush.com</div>}
          {single && single.body && (
            <button type="button" onClick={() => setShow(show ? '' : single.id)} className="mt-1 text-[11px] font-semibold text-[#7ee08f]">{show ? 'Fechar o e-mail' : 'Ver o e-mail'}</button>
          )}
          {single && show && <pre className="mt-2 whitespace-pre-wrap font-sans text-[12px] text-gray-200 bg-black/30 rounded-lg p-2.5 max-h-80 overflow-y-auto">{single.body}</pre>}
          {!single && open && (
            <ul className="mt-2 space-y-1.5">
              {g.items.map((x) => (
                <li key={x.id} className="text-[12px]">
                  <div className="flex items-center gap-2">
                    <span className="min-w-0 flex-1 truncate text-gray-200">{x.to}{x.review && g.state === 'pending' ? <span className="text-[#ff9b9b]"> · revisar</span> : null}</span>
                    {x.body && <button type="button" onClick={() => setShow(show === x.id ? '' : x.id)} className="text-[11px] font-semibold text-[#7ee08f]">{show === x.id ? 'fechar' : 'ver o e-mail'}</button>}
                    {g.state === 'pending' && <button type="button" disabled={busy} onClick={() => act('discard', [x.id])} className="text-[11px] text-[#ff9b9b]">{label('discard', [x.id], 'descartar')}</button>}
                  </div>
                  {x.subject && <div className="text-[11px] text-gray-400 truncate">{x.subject}</div>}
                  {show === x.id && <pre className="mt-1 whitespace-pre-wrap font-sans text-[12px] text-gray-200 bg-black/30 rounded-lg p-2.5 max-h-72 overflow-y-auto">{x.body}</pre>}
                </li>
              ))}
            </ul>
          )}
          {g.state === 'pending' && (
            <div className="flex flex-wrap items-center gap-2 mt-2">
              <button type="button" disabled={busy} onClick={() => act('approve', ids)} className="rounded-lg px-3 py-1.5 text-xs font-bold text-[#0e1513] bg-[#53c46c] hover:bg-[#6fd585] disabled:opacity-50">{busy ? '…' : label('approve', ids, single ? 'Aprovar' : `Aprovar os ${g.count}`)}</button>
              {single && <button type="button" disabled={busy} onClick={() => act('discard', ids)} className="rounded-lg px-3 py-1.5 text-xs font-semibold text-gray-300 border border-white/15 hover:text-white disabled:opacity-50">{label('discard', ids, 'Descartar')}</button>}
              {g.link && <a href={g.link} target="_blank" rel="noreferrer" className="text-[11px] font-semibold text-[#7ee08f]">Revisar o lote →</a>}
            </div>
          )}
          {g.state === 'pending' && <div className="text-[10px] text-gray-500 mt-1.5">{future ? `Se aprovar, sai em ${g.day.slice(8, 10)}/${g.day.slice(5, 7)} às 9h.` : 'Se aprovar, sai na hora.'}</div>}
          {g.state === 'approved' && (g.day > today || new Date(Date.now() - 3 * H).getUTCHours() < 8) && (
            <button type="button" disabled={busy} onClick={() => act('undo', ids)} className="mt-1.5 text-[11px] text-gray-400 hover:text-white">{label('undo', ids, 'Desfazer a aprovação')}</button>
          )}
        </div>
      </div>
    </div>
  );
};

// LinkedIn (Theo e Max): o que eles propõem aparece aqui e você decide aqui. A decisão sai da conta na hora;
// o robô grava no Authority Studio no começo da rodada seguinte e publica.
const nextRun = (robotId, now) => {
  const r = BY_ID[robotId];
  if (!r) return 0;
  let best = 0;
  for (let i = 0; i <= 8; i += 1) {
    const ymd = spYmd(now + i * 24 * H);
    const dow = new Date(`${ymd}T12:00:00Z`).getUTCDay();
    for (const run of r.runs) if (run.days && run.days.includes(dow)) { const t = slotAt(ymd, run.time); if (t > now && (!best || t < best)) best = t; }
    if (best) break;
  }
  return best;
};
const dayTime = (t, now) => {
  if (!t) return 'na próxima rodada';
  const iso = new Date(t).toISOString();
  const d = spYmd(t);
  if (d === spYmd(now)) return `hoje às ${hhmm(iso)}`;
  if (d === spYmd(now + 24 * H)) return `amanhã às ${hhmm(iso)}`;
  return `${DOW[new Date(`${d}T12:00:00Z`).getUTCDay()].toLowerCase()} ${ddmm(iso)} às ${hhmm(iso)}`;
};
const LI_GROUPS = [
  { kind: 'RESPOSTA_POST', title: 'Comentaram nos teus posts', sub: 'O Theo sugere a resposta. Sai pelo perfil ou pela página onde a pessoa comentou.' },
  { kind: 'RESPOSTA', title: 'Responderam ao teu comentário', sub: 'O Max sugere como continuar a conversa, pelo teu perfil.' },
  { kind: 'COMENTARIO', title: 'Comentários sniper', sub: 'Posts de referência em PI fora do Brasil. Sai pelo teu perfil, no máximo 3 por dia.' },
  { kind: 'POST', title: 'Posts para aprovar', sub: 'Aprovado vai para o agendador do próprio LinkedIn.' },
  { kind: 'ACAO', title: 'Ações únicas', sub: 'Sugestões para fazer uma vez. "Já fiz" quando você resolver; "Não quero" para descartar. Para o robô fazer por você, peça no chat do Claude.' },
];
const LI_TXT = {
  COMENTARIO: { ok: 'Aprovar comentário', no: 'Não comentar', label: 'Teu comentário (em inglês, pelo teu perfil)' },
  RESPOSTA: { ok: 'Aprovar resposta', no: 'Não responder', label: 'Tua resposta (em inglês, pelo teu perfil)' },
  RESPOSTA_POST: { ok: 'Aprovar resposta', no: 'Não responder', label: 'Resposta (em inglês)' },
  POST: { ok: 'Aprovar o post', no: 'Não publicar' },
  ACAO: { ok: 'Já fiz', no: 'Não quero' },
};
const DECIDED_TXT = { APROVADO: 'aprovado', IGNORADO: 'não vai sair', FEITO: 'feito', AJUSTE: 'ajuste pedido' };
const LI_MAX = 1250;

const LiCard = ({ x, now, onDecide }) => {
  const [text, setText] = useState(x.text_en || '');
  const [busy, setBusy] = useState(false);
  const [adjust, setAdjust] = useState(false);
  const [note, setNote] = useState('');
  const [openCopy, setOpenCopy] = useState(false);
  const inFlight = useRef(false);
  const robot = BY_ID[x.robot] || { name: x.robot, color: '#9aa5a0' };
  const t = LI_TXT[x.kind] || LI_TXT.COMENTARIO;
  const hasText = x.kind === 'COMENTARIO' || x.kind === 'RESPOSTA' || x.kind === 'RESPOSTA_POST';
  const failed = x.status === 'FALHOU';
  const wait = x.state === 'wait';
  const act = async (a, extra) => {
    if (inFlight.current) return;
    inFlight.current = true;
    setBusy(true);
    try { await onDecide(x, a, extra); } finally { setBusy(false); inFlight.current = false; }
  };
  const where = x.profile === 'TM_RUSH' ? 'pela página TM RUSH' : 'pelo teu perfil';
  const ex = x.extra || {};
  const next = dayTime(nextRun(x.robot, now), now);
  if (!wait) {
    const dec = x.decision || (x.state === 'approved' ? 'APROVADO' : '');
    const goes = dec === 'APROVADO' ? (x.kind === 'POST' ? `vai para o agendador na rodada de ${next}` : `sai ${where} a partir da rodada de ${next}`) : `o ${robot.name} atualiza o Studio na rodada de ${next}`;
    const tag = x.kind === 'ACAO' ? (dec === 'FEITO' ? 'você já fez' : 'descartada') : (DECIDED_TXT[dec] || dec.toLowerCase());
    return (
      <div className="rounded-xl px-3 py-2.5 border border-transparent bg-white/[0.04] flex gap-3 items-start">
        <Bar color={robot.color} />
        <div className="min-w-0 flex-1 text-[13px] leading-snug">
          <span className="font-semibold text-white">{x.author || x.context_pt}</span>
          <span className="ml-1.5 whitespace-nowrap text-[10px] font-semibold rounded px-1 py-0.5 bg-[#53c46c]/15 text-[#7ee08f]">{tag}</span>
          <div className="text-[11px] text-gray-400 mt-0.5">{robot.name} · {goes}{x.state === 'decided' && x.note && dec === 'AJUSTE' ? ` · “${x.note}”` : ''}</div>
        </div>
        <button type="button" disabled={busy} onClick={() => act('undo')} className="shrink-0 text-[11px] text-gray-400 hover:text-white disabled:opacity-50">{busy ? '…' : 'Desfazer'}</button>
      </div>
    );
  }
  const tooLong = text.trim().length > LI_MAX;
  return (
    <div className="rounded-2xl border border-[#53c46c]/60 bg-[#53c46c]/[0.06] p-4">
      <div className="flex gap-3">
        <Bar color={robot.color} />
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-gray-400">
            <span className="font-semibold text-white text-[12px]">{robot.name}</span>
            {x.category && <span>{x.category}</span>}
            {x.kind === 'POST' && ex.slot_date && <span>{`${ex.slot_date.slice(8, 10)}/${ex.slot_date.slice(5, 7)}`} às {ex.time || '10:00'} · {x.profile === 'TM_RUSH' ? 'página TM RUSH' : 'teu perfil'}</span>}
            {ex.post_date && <span>post de {`${ex.post_date.slice(8, 10)}/${ex.post_date.slice(5, 7)}`}</span>}
            {x.found_at && <span>visto {when(x.found_at)}</span>}
            {failed && <span className="font-semibold rounded px-1 py-0.5 bg-[#ff6b6b]/15 text-[#ff9b9b]">não saiu</span>}
          </div>
          {x.author && (
            <div className="mt-1.5">
              <div className="font-semibold text-white text-[14px] leading-snug">{x.author}</div>
              {x.headline && <div className="text-[11px] text-gray-400 leading-snug">{x.headline}</div>}
            </div>
          )}
          {(x.kind === 'POST' || x.kind === 'ACAO') && <div className="mt-1.5 font-semibold text-white text-[14px] leading-snug">{x.context_pt}</div>}
          {x.kind === 'RESPOSTA_POST' && x.original && <p className="mt-2 whitespace-pre-wrap text-[13px] text-gray-200 border-l-2 border-white/20 pl-2.5">{x.original}</p>}
          {x.kind !== 'POST' && x.kind !== 'ACAO' && x.context_pt && <p className="mt-2 text-[13px] text-gray-300 leading-snug">{x.kind === 'RESPOSTA_POST' ? <span className="font-semibold text-gray-200">Em português: </span> : null}{x.context_pt}</p>}
          {x.kind === 'ACAO' && x.original && <p className="mt-1.5 whitespace-pre-wrap text-[13px] text-gray-300 leading-snug">{x.original}</p>}
          {x.kind === 'POST' && x.original && <p className="mt-1 text-[12px] text-gray-400 leading-snug">{x.original}</p>}
          {x.why_pt && <p className="mt-2 text-[12px] leading-snug rounded-lg px-2.5 py-2 bg-[#e8c547]/10 text-[#f1d36b]">{x.why_pt}</p>}
          {failed && ex.erro && <p className="mt-2 text-[12px] text-[#ff9b9b]">Por que não saiu: {ex.erro}</p>}
          {x.kind === 'POST' && (
            <div className="mt-2">
              <pre className={`whitespace-pre-wrap font-sans text-[13px] text-gray-200 bg-black/30 rounded-lg p-2.5 overflow-hidden ${openCopy ? '' : 'max-h-40'}`}>{x.text_en}</pre>
              <button type="button" onClick={() => setOpenCopy(!openCopy)} className="mt-1 text-[11px] font-semibold text-[#7ee08f]">{openCopy ? 'Mostrar menos' : 'Ler o post inteiro'}</button>
              {ex.image && <span className="ml-3 text-[11px] text-gray-400">tem imagem: veja no Authority Studio</span>}
            </div>
          )}
          {hasText && (
            <div className="mt-2">
              <label htmlFor={`li-${x.id}`} className="block text-[11px] font-semibold text-gray-300 mb-1">{x.kind === 'RESPOSTA_POST' ? `${t.label}, ${where}` : t.label}</label>
              <textarea id={`li-${x.id}`} value={text} onChange={(e) => setText(e.target.value)} rows={Math.min(9, Math.max(3, Math.ceil(text.length / 70)))}
                className="w-full rounded-lg bg-black/30 border border-white/15 text-[13px] leading-relaxed text-gray-100 p-2.5 focus:outline-none focus:border-[#53c46c]" />
              <div className={`text-[10px] mt-0.5 ${tooLong ? 'text-[#ff9b9b]' : 'text-gray-500'}`}>Pode editar antes de aprovar · {text.trim().length}/{LI_MAX}</div>
            </div>
          )}
          {adjust && (
            <div className="mt-2">
              <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} placeholder="O que você quer mudar? Ex.: mais curto, troca o exemplo…" className="w-full rounded-lg bg-black/30 border border-white/15 text-[13px] text-gray-100 p-2.5 focus:outline-none focus:border-[#53c46c]" />
            </div>
          )}
          <div className="flex flex-wrap items-center gap-2 mt-2.5">
            {x.kind === 'ACAO' ? (
              <button type="button" disabled={busy} onClick={() => act('done')} className="rounded-lg px-3 py-1.5 text-xs font-bold text-[#0e1513] bg-[#53c46c] hover:bg-[#6fd585] disabled:opacity-50">{busy ? '…' : t.ok}</button>
            ) : adjust ? (
              <>
                <button type="button" disabled={busy || !note.trim()} onClick={() => act('adjust', { note: note.trim() })} className="rounded-lg px-3 py-1.5 text-xs font-bold text-[#0e1513] bg-[#53c46c] hover:bg-[#6fd585] disabled:opacity-50">{busy ? '…' : 'Enviar pedido de ajuste'}</button>
                <button type="button" onClick={() => setAdjust(false)} className="rounded-lg px-3 py-1.5 text-xs font-semibold text-gray-300 border border-white/15 hover:text-white">Cancelar</button>
              </>
            ) : (
              <button type="button" disabled={busy || (hasText && (!text.trim() || tooLong))} onClick={() => act('approve', hasText ? { text: text.trim() } : {})} className="rounded-lg px-3 py-1.5 text-xs font-bold text-[#0e1513] bg-[#53c46c] hover:bg-[#6fd585] disabled:opacity-50">{busy ? '…' : failed ? 'Tentar de novo' : t.ok}</button>
            )}
            {!adjust && <button type="button" disabled={busy} onClick={() => act('ignore')} className="rounded-lg px-3 py-1.5 text-xs font-semibold text-gray-300 border border-white/15 hover:text-white disabled:opacity-50">{t.no}</button>}
            {x.kind === 'POST' && !adjust && <button type="button" disabled={busy} onClick={() => setAdjust(true)} className="rounded-lg px-3 py-1.5 text-xs font-semibold text-gray-300 border border-white/15 hover:text-white disabled:opacity-50">Pedir ajuste</button>}
            {x.url && <a href={x.url} target="_blank" rel="noreferrer" className="text-[11px] font-semibold text-[#7ee08f]">{x.kind === 'RESPOSTA_POST' ? 'Abrir no LinkedIn ↗' : 'Abrir o post ↗'}</a>}
          </div>
          {x.kind !== 'ACAO' && <div className="text-[10px] text-gray-500 mt-1.5">Se aprovar, {x.kind === 'POST' ? 'vai para o agendador na rodada' : `sai ${where} a partir da rodada`} do {robot.name} de {next}.</div>}
        </div>
      </div>
    </div>
  );
};

const LinkedInSection = ({ li, now, studio, notice, onDecide }) => {
  const items = (li && li.items) || [];
  const wait = items.filter((x) => x.state === 'wait');
  const done = items.filter((x) => x.state !== 'wait');
  const sync = (li && li.sync) || {};
  const syncTxt = ['max', 'theo'].filter((k) => sync[k]).map((k) => `${BY_ID[k].name} ${when(sync[k])}`).join(' · ');
  return (
    <section id="linkedin" className="mt-8 rounded-2xl border border-white/10 p-4 md:p-5 scroll-mt-4" style={{ background: 'rgba(255,255,255,0.03)' }} aria-labelledby="linkedin-h">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-1">
        <h2 id="linkedin-h" className="text-white font-bold text-lg">LinkedIn <span className="text-gray-400 font-normal text-sm">· Theo e Max</span></h2>
        <span className="text-xs text-gray-400">{wait.length ? <span className="text-[#7ee08f] font-semibold">{plural(wait.length, ['esperando você', 'esperando você'])}</span> : 'nada esperando você'}</span>
      </div>
      <p className="text-xs text-gray-400 mb-4">Você decide aqui e o item sai da conta na hora. O robô grava no Authority Studio e publica na rodada seguinte.{syncTxt ? ` Lista do Studio conferida: ${syncTxt}.` : ''}</p>
      {notice && <div className="mb-3 rounded-xl border border-[#53c46c]/50 bg-[#53c46c]/10 px-4 py-2.5 text-sm text-[#b9f0c4]">{notice}</div>}
      {((li && li.stale) || []).map((rb) => (
        <p key={rb} className="mb-3 text-xs rounded-lg px-3 py-2 bg-[#e8c547]/10 text-[#f1d36b]">O {(BY_ID[rb] || { name: rb }).name} rodou depois da última lista e não mandou a nova: a conta dele vem do relatório da rodada, e o que é dele aqui pode estar desatualizado.</p>
      ))}
      {!wait.length && <p className="text-sm text-gray-400 mb-2">Nada do LinkedIn esperando você agora. ✓</p>}
      <div className="space-y-5">
        {LI_GROUPS.map((g) => {
          const list = wait.filter((x) => x.kind === g.kind);
          if (!list.length) return null;
          return (
            <div key={g.kind}>
              <h3 className="text-sm font-bold text-white">{g.title} <span className="text-gray-400 font-normal">· {list.length}</span></h3>
              <p className="text-[11px] text-gray-500 mb-2">{g.sub}</p>
              <div className="grid grid-cols-1 xl:grid-cols-2 gap-3">
                {list.map((x) => <LiCard key={x.id} x={x} now={now} onDecide={onDecide} />)}
              </div>
            </div>
          );
        })}
        {done.length > 0 && (
          <div>
            <h3 className="text-sm font-bold text-white mb-2">Decidido, esperando a rodada do robô <span className="text-gray-400 font-normal">· {done.length}</span></h3>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
              {done.map((x) => <LiCard key={x.id} x={x} now={now} onDecide={onDecide} />)}
            </div>
          </div>
        )}
      </div>
      {studio && <a href={studio} target="_blank" rel="noreferrer" className="inline-block mt-4 text-xs font-semibold text-[#7ee08f]">Histórico e métricas no Authority Studio →</a>}
    </section>
  );
};

const Need = ({ n }) => (
  <div className="rounded-2xl border p-4" style={{ borderColor: `${TONE[n.tone] || '#fff'}66`, background: `${TONE[n.tone] || '#fff'}12` }}>
    <div className="flex items-start gap-3">
      <div className="text-2xl font-bold leading-none pt-0.5" style={{ color: TONE[n.tone] }}>{n.count}</div>
      <div className="min-w-0 flex-1">
        <div className="font-semibold text-white leading-snug">{n.title}</div>
        {n.detail && <div className="text-xs text-gray-300 mt-1 leading-snug">{n.detail}</div>}
        {n.items && n.items.length > 0 && (
          <ul className="mt-3 space-y-1.5">
            {n.items.map((x) => (
              <li key={x.id} className="flex items-center gap-2 text-[13px]">
                <span className="min-w-0 flex-1 truncate text-gray-200">{x.subject || `${x.id} · ${x.payer}`}{x.to ? <span className="text-gray-500"> · {x.to}</span> : null}{x.review ? <span className="text-[#ff9b9b]"> · revisar</span> : null}</span>
                <a href={x.link} target="_blank" rel="noreferrer" className="shrink-0 rounded-lg px-2.5 py-1 text-xs font-semibold text-[#0e1513]" style={{ background: TONE[n.tone] }}>Abrir</a>
              </li>
            ))}
          </ul>
        )}
        {n.link && <a href={n.link} {...(n.link.startsWith('#') ? {} : { target: '_blank', rel: 'noreferrer' })} className="inline-block mt-3 rounded-lg px-3 py-1.5 text-xs font-semibold text-[#0e1513]" style={{ background: TONE[n.tone] }}>{n.linkLabel || 'Abrir'}</a>}
        {n.kind === 'leads' && <a href="#leads" className="inline-block mt-3 text-xs font-semibold" style={{ color: TONE.gold }}>Ver os leads ↓</a>}
      </div>
    </div>
  </div>
);

// quadro da equipe da Marcas Já: a próxima etapa de cada ordem de serviço (elas marcam feito no painel da equipe)
const WHO_TONE = { Gabriele: '#e8c547', Carol: '#7fd1ff', Belle: '#ff9bd0' };
const WhoChip = ({ who }) => {
  const c = WHO_TONE[who] || '#9fd4ff';
  return <span className="shrink-0 text-[11px] font-bold rounded-full px-2 py-0.5" style={{ color: c, background: `${c}22` }}>{who}</span>;
};
const TeamBoard = ({ team, link, onCobrar }) => {
  const pending = (team && team.pending) || [];
  const done = (team && team.done) || [];
  return (
    <div className="space-y-2">
      {!pending.length && <div className="rounded-2xl border border-white/10 bg-white/[0.03] px-4 py-3 text-sm text-gray-400">Nada parado com a equipe agora. ✓</div>}
      {pending.map((x) => (
        <div key={`${x.ref}-${x.os}-${x.task}`} className={`rounded-2xl border px-4 py-3 ${x.days >= 2 && !x.test ? 'border-[#ff6b6b]/50 bg-[#ff6b6b]/[0.06]' : 'border-[#4aa3ff]/40 bg-[#4aa3ff]/[0.06]'} ${x.test ? 'opacity-70' : ''}`}>
          <div className="flex items-center gap-2">
            <WhoChip who={x.who} />
            <span className="min-w-0 flex-1 font-semibold text-white text-[14px] leading-snug">{x.task}</span>
            <span className={`shrink-0 text-[11px] ${x.days >= 2 && !x.test ? 'text-[#ff9b9b] font-semibold' : 'text-gray-400'}`}>{x.days === 0 ? 'desde hoje' : `há ${plural(x.days, ['dia', 'dias'])}`}</span>
          </div>
          <div className="text-xs text-gray-400 mt-1">
            {x.mark}{x.os ? ` · ${x.os}` : ''} · {x.ref}
            {x.test && <span className="ml-1.5 text-[10px] font-bold rounded px-1 py-0.5 bg-white/10 text-gray-300">TESTE</span>}
          </div>
          {x.extra && <div className="text-xs text-gray-300 mt-1">{x.extra}</div>}
          {!x.test && onCobrar && (
            <div className="flex flex-wrap items-center gap-2 mt-2">
              <button type="button" onClick={() => onCobrar(x)} className="rounded-lg px-3 py-1.5 text-xs font-bold text-[#0e1513] bg-[#7fd1ff] hover:bg-[#a5e0ff]">Cobrar a equipe</button>
              {x.cobrado_at && <span className="text-[11px] text-gray-400">cobrado {when(x.cobrado_at)}</span>}
            </div>
          )}
        </div>
      ))}
      {done.length > 0 && (
        <div className="rounded-2xl border border-white/10 bg-white/[0.03] px-4 py-3">
          <div className="text-xs font-semibold text-gray-400 mb-2">Feito nas últimas 48 h</div>
          <ul className="space-y-1">
            {done.map((x) => (
              <li key={`${x.ref}-${x.task}-${x.at}`} className="text-[13px] text-gray-200 flex gap-2">
                <span>✅</span>
                <span className="min-w-0 flex-1">{x.task} · {x.mark}{x.test ? ' (teste)' : ''} <span className="text-gray-500">· {x.who}, {when(x.at)}</span></span>
              </li>
            ))}
          </ul>
        </div>
      )}
      {link && <a href={link} target="_blank" rel="noreferrer" className="inline-block text-xs font-semibold text-[#7ee08f]">Abrir o painel da equipe →</a>}
    </div>
  );
};

// gestão da equipe: onde estão os processos, quem espera o cliente, prazos e tempo de cada etapa
const GestaoEquipe = ({ g }) => {
  if (!g) return null;
  const warm = ['cliente', 'nf', 'exigencia'];
  return (
    <section className="mt-8 rounded-2xl border border-white/10 p-4 md:p-5" style={{ background: 'rgba(255,255,255,0.03)' }} aria-labelledby="gestao">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-3">
        <h2 id="gestao" className="text-white font-bold text-lg">Gestão da equipe</h2>
        <span className="text-xs text-gray-400">{plural(g.processes, ['processo', 'processos'])} · {g.stale ? <span className="text-[#ff9b9b] font-semibold">{plural(g.stale, ['item parado', 'itens parados'])} há 2 dias ou mais</span> : 'nada parado há 2 dias ou mais'}</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-5 lg:grid-cols-10 gap-2 mb-4">
        {g.funnel.map((f) => (
          <div key={f.key} className="rounded-xl border px-3 py-2.5" style={{ borderColor: f.count && warm.includes(f.key) ? '#e8c54766' : f.count ? '#53c46c55' : 'rgba(255,255,255,0.08)', background: f.count && warm.includes(f.key) ? 'rgba(232,197,71,0.08)' : f.count ? 'rgba(83,196,108,0.07)' : 'transparent' }}>
            <div className="text-2xl font-bold" style={{ color: f.count && warm.includes(f.key) ? '#f1d36b' : f.count ? '#7ee08f' : '#6b7672' }}>{f.count}</div>
            <div className="text-[11px] text-gray-300 leading-tight">{f.label}</div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
        <div className="rounded-xl border border-white/10 px-4 py-3">
          <div className="text-sm font-bold text-white mb-2">Esperando o cliente</div>
          {!g.waiting.length && <div className="text-xs text-gray-400">Ninguém esperando o cliente.</div>}
          {g.waiting.map((w) => (
            <div key={w.ref} className="py-1.5 border-t border-white/5 first:border-0">
              <div className="flex items-center gap-2 text-[13px]"><span className="font-semibold text-white flex-1 min-w-0 truncate">{w.mark}</span><span className={`text-[11px] ${w.days >= 3 ? 'text-[#ff9b9b] font-semibold' : 'text-gray-400'}`}>{w.days === 0 ? 'desde hoje' : `há ${plural(w.days, ['dia', 'dias'])}`}</span></div>
              <div className="text-[11px] text-gray-400">{w.client} · falta {w.falta}</div>
            </div>
          ))}
          <div className="text-[11px] text-gray-500 mt-2">A Belle cobra o cliente pelo painel da equipe; o Ivo também lembra sozinho.</div>
        </div>
        <div className="rounded-xl border border-white/10 px-4 py-3">
          <div className="text-sm font-bold text-white mb-2">Prazos nos próximos 7 dias</div>
          {!g.deadlines.length && <div className="text-xs text-gray-400">Nenhum prazo nos próximos 7 dias.</div>}
          {g.deadlines.map((d) => (
            <div key={`${d.process}-${d.date}`} className="py-1.5 border-t border-white/5 first:border-0">
              <div className="flex items-center gap-2 text-[13px]"><span className="font-semibold text-white flex-1 min-w-0 truncate">{d.mark} · cl. {d.cls}</span><span className={`text-[11px] font-semibold ${d.days <= 3 ? 'text-[#f1d36b]' : 'text-gray-300'}`}>{d.days === 0 ? 'hoje' : `${plural(d.days, ['dia', 'dias'])}`}</span></div>
              <div className="text-[11px] text-gray-400">{d.what} · {d.date.split('-').reverse().join('/')} · {d.process}</div>
            </div>
          ))}
        </div>
        <div className="rounded-xl border border-white/10 px-4 py-3">
          <div className="text-sm font-bold text-white mb-2">Tempo de cada etapa <span className="text-gray-400 font-normal text-xs">· últimos 30 dias</span></div>
          {!g.tempos.length && <div className="text-xs text-gray-400">Ainda sem etapas concluídas pela equipe para medir.</div>}
          {g.tempos.map((t) => (
            <div key={t.step} className="flex items-center gap-2 py-1 text-[13px]">
              <span className="flex-1 min-w-0 truncate text-gray-200">{t.step}</span>
              <span className={`text-[12px] font-semibold ${t.days > 2 ? 'text-[#ff9b9b]' : 'text-[#7ee08f]'}`}>{t.days < 1 ? 'menos de 1 dia' : `${String(t.days).replace('.', ',')} dias`}</span>
              <span className="text-[11px] text-gray-500 w-10 text-right">{t.n}×</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// dia de envio vem como AAAA-MM-DD (sem hora): mostra direto, sem converter fuso
const dayBR = (d) => (/^\d{4}-\d{2}-\d{2}$/.test(String(d || '')) ? `${d.slice(8, 10)}/${d.slice(5, 7)}` : d ? ddmm(d) : '');

// card de um lead do Grok: o que o Pedro fez com ele, e o botão de aprovar o e-mail ali mesmo
const LeadCard = ({ l, decide }) => {
  const [busy, setBusy] = useState('');
  const e = l.email || {};
  const run = async (a) => { setBusy(a); try { await decide(a, [e.id]); } finally { setBusy(''); } };
  return (
    <div className={`rounded-2xl border p-4 ${l.state === 'pending' ? 'border-[#e8c547]/50 bg-[#e8c547]/[0.06]' : 'border-white/10 bg-white/[0.04]'}`}>
      <div className="flex items-center gap-2">
        <span className="font-semibold text-white truncate">{l.empresa}</span>
        {l.prioridade && <span className={`ml-auto shrink-0 text-[10px] font-bold rounded px-1.5 py-0.5 ${/alta/i.test(l.prioridade) ? 'bg-[#53c46c]/20 text-[#7ee08f]' : 'bg-white/10 text-gray-300'}`}>{l.prioridade}</span>}
      </div>
      <div className="text-xs text-gray-400 mt-0.5">{[l.pais, l.setor, l.marca && `marca ${l.marca}`].filter(Boolean).join(' · ')}</div>
      {l.sinal && <p className="text-sm text-gray-200 leading-snug mt-2">{l.sinal}</p>}
      <div className="flex items-center gap-3 mt-2 text-xs">
        <span className="text-gray-500">{l.at ? ddmm(l.at) : ''}</span>
        {l.url && <a href={l.url} target="_blank" rel="noreferrer" className="font-semibold text-[#f1d36b]">Fonte →</a>}
      </div>
      <div className="mt-3 pt-3 border-t border-white/10 text-xs">
        {l.state === 'pending' && (
          <>
            <div className="text-[#f1d36b] font-semibold">E-mail pronto para {e.to || 'o contato'}</div>
            {e.subject && <div className="text-gray-300 mt-0.5 truncate">{e.subject}</div>}
            <div className="flex items-center gap-2 mt-2">
              <button type="button" disabled={!!busy} onClick={() => run('approve')} className="rounded-lg px-3 py-1.5 text-xs font-bold text-[#0e1513] bg-[#53c46c] hover:bg-[#6fd585] disabled:opacity-50">{busy === 'approve' ? '…' : 'Aprovar'}</button>
              <button type="button" disabled={!!busy} onClick={() => run('discard')} className="rounded-lg px-3 py-1.5 text-xs font-semibold text-gray-300 border border-white/15 hover:text-white disabled:opacity-50">{busy === 'discard' ? '…' : 'Descartar'}</button>
              <span className="text-gray-500">{e.day ? `sai às 9h de ${dayBR(e.day)}` : 'sai às 9h do dia marcado'}</span>
            </div>
          </>
        )}
        {l.state === 'approved' && <div className="text-[#7ee08f] font-semibold">Aprovado · sai às 9h de {dayBR(e.day)}</div>}
        {l.state === 'sent' && <div className="text-gray-400">E-mail enviado {e.sent_at ? `em ${ddmm(e.sent_at)}` : ''}{e.to ? ` para ${e.to}` : ''}</div>}
        {l.state === 'linkedin' && <div className="text-[#8fa6ff] font-semibold">Sem e-mail confirmado: pauta do Max no LinkedIn</div>}
        {l.state === 'novo' && <div className="text-gray-400">O Pedro escreve o e-mail no próximo dia útil, às 10h</div>}
      </div>
    </div>
  );
};

const Section = ({ id, title, sub, children }) => (
  <section id={id} className="mt-10">
    <h2 className="text-white font-bold text-lg mb-1">{title}</h2>
    {sub && <p className="text-sm text-gray-400 mb-4">{sub}</p>}
    {children}
  </section>
);

const CommandPage = () => {
  const [key, setKey] = useState('');
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const [onlyLive, setOnlyLive] = useState(false);
  const [theme, toggleTheme] = useTheme('dark', '#0e1513');
  const [now, setNow] = useState(Date.now());
  const scroller = useRef(null);
  const todayCol = useRef(null);

  useEffect(() => { setKey(readKey()); }, []);

  const load = useCallback(async (k) => {
    if (!k) return;
    setLoading(true);
    try {
      const r = await fetch(`${API}/tmr-command?k=${encodeURIComponent(k)}`, { cache: 'no-store' });
      const j = await r.json().catch(() => ({}));
      if (r.status === 403 || j.ok === false) { setErr('Chave inválida. Entre de novo em tmrush.com/entrar.'); setData(null); } else { setData(j); setErr(''); }
    } catch (e) {
      setErr('Não consegui falar com o sistema agora. Tento de novo em 1 minuto.');
    } finally {
      setLoading(false);
      setNow(Date.now());
    }
  }, []);

  // atualiza a cada minuto só com a aba na tela (aba escondida não consulta o servidor)
  usePolling(() => load(key), 60000, !!key);

  const { days, free } = useMemo(() => buildWeek(data, now), [data, now]);

  const [notice, setNotice] = useState('');
  const [teamNotice, setTeamNotice] = useState('');
  const cobrar = useCallback(async (x) => {
    if (!window.confirm(`Mandar um e-mail para a equipe cobrando "${x.task}" (${x.mark})?`)) return;
    try {
      const r = await fetch(`${API}/tmr-cobrar`, { method: 'POST', body: new URLSearchParams({ k: key, key: x.key || '', task: x.task || '', mark: x.mark || '', ref: x.ref || '', who: x.who || '', os: x.os || '', days: String(x.days || 0) }) });
      const j = await r.json().catch(() => ({}));
      setTeamNotice(j.ok ? (j.already ? 'A equipe já foi cobrada por isso há menos de 30 minutos.' : 'Cobrança enviada para a equipe por e-mail.') : (j.error || 'Não deu certo. Tente de novo.'));
    } catch (e) {
      setTeamNotice('Não consegui falar com o sistema agora. Tente de novo.');
    } finally {
      setTimeout(() => setTeamNotice(''), 8000);
      await load(key);
    }
  }, [key, load]);
  const decide = useCallback(async (a, ids) => {
    try {
      const r = await fetch(`${API}/tmr-agenda`, { method: 'POST', body: new URLSearchParams({ k: key, a, ids: ids.join(',') }) });
      const j = await r.json().catch(() => ({}));
      if (!j.ok) { setNotice(j.error || 'Não deu certo. Tente de novo.'); return; }
      const parts = [];
      if (j.sending) parts.push(`${plural(j.sending, ['e-mail saindo', 'e-mails saindo'])} agora`);
      if (j.scheduled) parts.push(`${plural(j.scheduled, ['agendado', 'agendados'])} para as 9h do dia`);
      if (j.discarded) parts.push(plural(j.discarded, ['descartado', 'descartados']));
      if (j.undone) parts.push(`${plural(j.undone, ['aprovação desfeita', 'aprovações desfeitas'])}`);
      if (j.skipped && j.skipped.length) parts.push(`${j.skipped.length} já tinha${j.skipped.length === 1 ? '' : 'm'} mudado`);
      setNotice(`${parts.join(' · ') || 'Feito'}.`);
    } catch (e) {
      setNotice('Não consegui falar com o sistema agora. Tente de novo.');
    } finally {
      setTimeout(() => setNotice(''), 8000);
      await load(key);
    }
  }, [key, load]);
  const [liNotice, setLiNotice] = useState('');
  const decideLi = useCallback(async (x, a, extra = {}) => {
    const name = (BY_ID[x.robot] || { name: x.robot }).name;
    try {
      const r = await fetch(`${API}/tmr-li-decide`, { method: 'POST', body: new URLSearchParams({ k: key, id: x.id, a, ...extra }) });
      const j = await r.json().catch(() => ({}));
      if (!j.ok) { setLiNotice(j.error || 'Não deu certo. Tente de novo.'); return; }
      if (j.already) { setLiNotice('Isso já tinha sido decidido. A lista foi atualizada.'); return; }
      const next = dayTime(nextRun(x.robot, Date.now()), Date.now());
      const txt = {
        approve: x.kind === 'POST' ? `Post aprovado. O ${name} agenda no LinkedIn na rodada de ${next}.` : `Aprovado. O ${name} publica na rodada de ${next}.`,
        ignore: x.kind === 'ACAO' ? 'Descartado: não vai ser feito.' : x.kind === 'POST' ? 'Esse post não vai sair.' : 'Marcado para não sair.',
        done: 'Marcado como resolvido por você.',
        adjust: 'Pedido de ajuste anotado. Me chame no Claude para refazer o post.',
        undo: 'Decisão desfeita: voltou para você.',
      };
      setLiNotice(txt[a] || 'Feito.');
    } catch (e) {
      setLiNotice('Não consegui falar com o sistema agora. Tente de novo.');
    } finally {
      setTimeout(() => setLiNotice(''), 8000);
      await load(key);
    }
  }, [key, load]);
  const agenda = (data && data.agenda) || [];
  const today = (data && data.today) || spYmd(now);
  const lastDay = days.length ? days[days.length - 1].ymd : today;
  const later = agenda.filter((g) => g.day > lastDay);

  useEffect(() => {
    if (scroller.current && todayCol.current) scroller.current.scrollLeft = Math.max(0, todayCol.current.offsetLeft - scroller.current.offsetLeft - 24);
  }, [data]);
  // link de fora para uma seção (o Authority Studio abre /comando#linkedin): rola até ela quando os dados chegam
  const jumped = useRef(false);
  useEffect(() => {
    if (!data || jumped.current) return;
    jumped.current = true;
    const h = window.location.hash.replace('#', '');
    if (!h || h.startsWith('k=')) return;
    const el = document.getElementById(h);
    if (el) setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 80);
  }, [data]);

  if (!key) {
    return (
      <main className="min-h-screen flex items-center justify-center px-4" style={{ background: '#0e1513' }}>
        <div className="max-w-sm text-center text-gray-300">
          <img src="/images/tm-rushlogo.svg" alt="TM RUSH" className="h-8 mx-auto mb-4 brightness-0 invert" />
          <p className="font-semibold text-white mb-2">Comando</p>
          <p className="text-sm">Abra pelo link com a chave de acesso. Depois da primeira vez, este navegador lembra sozinho.</p>
          <a href="/entrar?ir=/comando" className="inline-block mt-5 rounded-xl bg-white text-[#0e1513] font-semibold text-sm px-4 py-2.5 hover:bg-gray-100">Entrar com e-mail e senha</a>
        </div>
      </main>
    );
  }

  const runs = (data && data.runs) || [];
  const real = runs.filter((r) => !r.event);
  const ok24 = real.filter((r) => r.ok && Date.now() - ms(r.at) < 24 * H).length;
  const fail36 = runs.filter((r) => !r.ok && Date.now() - ms(r.at) < 36 * H).length;
  const liveCount = ROBOTS.filter((r) => statusOf(r, null, data) === 'live').length;
  const needs = (data && data.needs) || [];
  const lastRun = (id) => runs.find((r) => r.robot === id);
  const recent = runs.slice(0, 30);

  return (
    <main className="min-h-screen" style={{ background: '#0e1513' }}>
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-wrap items-center gap-3 mb-6">
          <img src="/images/tm-rushlogo.svg" alt="TM RUSH" className="tmr-logo h-7 brightness-0 invert" />
          <span className="text-xl font-bold" style={{ color: '#53c46c' }}>Comando</span>
          <a href="/ops" className="text-[11px] rounded-lg border border-white/15 px-2 py-1 text-gray-300 hover:text-white">Painel da equipe</a>
          <a href="/desk" className="text-[11px] rounded-lg border border-white/15 px-2 py-1 text-gray-300 hover:text-white">Desk</a>
          <span className="ml-auto text-[11px] text-gray-500">
            {loading ? 'atualizando…' : data ? `atualizado às ${hhmm(data.now)} · atualiza sozinho a cada minuto` : ''}
          </span>
          <ThemeButton theme={theme} onToggle={toggleTheme} className="text-[11px] rounded-lg border border-white/15 px-2 py-1 text-gray-300 hover:text-white" />
          <button type="button" onClick={() => load(key)} className="text-[11px] rounded-lg border border-white/15 px-2 py-1 text-gray-300 hover:text-white">Atualizar</button>
        </div>

        {err && <div className="mb-4 rounded-xl border border-[#ff6b6b]/50 bg-[#ff6b6b]/10 px-4 py-3 text-sm text-[#ffb3b3]">{err}</div>}

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
          <div className="rounded-xl border px-4 py-3" style={{ borderColor: '#53c46c', background: 'rgba(83,196,108,0.08)' }}>
            <div className="text-2xl font-bold" style={{ color: '#53c46c' }}>{data ? data.you : '—'}</div>
            <div className="text-xs text-gray-300">precisam de você</div>
          </div>
          <div className="rounded-xl border border-white/10 bg-white/[0.04] px-4 py-3">
            <div className="text-2xl font-bold text-white">{data ? ok24 : '—'}</div>
            <div className="text-xs text-gray-400">{ok24 === 1 ? 'rodada certa' : 'rodadas certas'} em 24 h</div>
          </div>
          <div className="rounded-xl border px-4 py-3" style={{ borderColor: fail36 ? '#ff6b6b88' : 'rgba(255,255,255,0.1)', background: fail36 ? 'rgba(255,107,107,0.08)' : 'rgba(255,255,255,0.04)' }}>
            <div className="text-2xl font-bold" style={{ color: fail36 ? '#ff6b6b' : '#fff' }}>{data ? fail36 : '—'}</div>
            <div className="text-xs text-gray-400">{fail36 === 1 ? 'falha' : 'falhas'} em 36 h</div>
          </div>
          <div className="rounded-xl border border-white/10 bg-white/[0.04] px-4 py-3">
            <div className="text-2xl font-bold text-white">{liveCount} de {ROBOTS.length}</div>
            <div className="text-xs text-gray-400">robôs no ar</div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div>
            <h2 className="text-white font-bold text-lg mb-1">Com você</h2>
            <p className="text-xs text-gray-400 mb-3">O que só você aprova: e-mails, follow-ups, invoices e LinkedIn.</p>
            {data && !needs.length && <p className="text-sm text-gray-400 mb-2">Nada esperando você agora. ✓</p>}
            <div className="grid grid-cols-1 gap-3">
              {needs.map((n) => <Need key={n.kind} n={n} />)}
            </div>
          </div>
          <div>
            <h2 className="text-white font-bold text-lg mb-1">Com a equipe <span className="text-gray-400 font-normal text-sm">· Marcas Já</span></h2>
            <p className="text-xs text-gray-400 mb-3">A próxima etapa de cada ordem de serviço. Elas marcam feito no painel da equipe e aparece aqui. Parado há 2 dias ou mais fica vermelho.</p>
            {teamNotice && <div className="mb-3 rounded-xl border border-[#7fd1ff]/50 bg-[#7fd1ff]/10 px-4 py-2.5 text-sm text-[#cfeeff]">{teamNotice}</div>}
            {data && <TeamBoard team={data.team} link={data.links && data.links.ops} onCobrar={cobrar} />}
          </div>
        </div>

        {data && data.linkedin && data.linkedin.live && <LinkedInSection li={data.linkedin} now={now} studio={data.links && data.links.studio} notice={liNotice} onDecide={decideLi} />}

        {data && <GestaoEquipe g={data.gestao} />}

        <div id="agenda" className="flex flex-wrap items-center gap-x-4 gap-y-2 mt-10 mb-3 text-xs text-gray-400 scroll-mt-4">
          <span className="font-bold text-white text-sm mr-2">Agenda dos robôs</span>
          <span><span className="inline-block w-2.5 h-2.5 rounded-sm border border-[#53c46c] bg-[#53c46c]/20 align-middle mr-1" />para você aprovar</span>
          <span>✅ deu certo</span><span>❌ falhou (toque para ver o motivo)</span><span>⚠️ não registrou</span><span>⏳ rodando</span>
          <span><span className="text-[10px] font-bold bg-[#e8c547]/20 text-[#f1d36b] rounded px-1 py-0.5">GROK</span> rotina do Grok</span>
          <label className="flex items-center gap-1.5 ml-auto cursor-pointer"><input type="checkbox" checked={onlyLive} onChange={(e) => setOnlyLive(e.target.checked)} /> só o que já está no ar</label>
        </div>

        {notice && <div className="mb-3 rounded-xl border border-[#53c46c]/50 bg-[#53c46c]/10 px-4 py-2.5 text-sm text-[#b9f0c4]">{notice}</div>}

        <div ref={scroller} className="flex items-start gap-4 overflow-x-auto pb-4 snap-x">
          {days.map((d) => (
            <section key={d.ymd} ref={d.today ? todayCol : null} className={`snap-start shrink-0 w-[290px] rounded-2xl p-3 border ${d.today ? 'border-[#53c46c]' : 'border-white/10'}`} style={{ background: 'rgba(255,255,255,0.03)' }}>
              <div className="flex items-baseline justify-between px-1 mb-3">
                <h3 className="text-lg font-bold" style={{ color: d.today ? '#53c46c' : d.i < 0 ? '#9aa5a0' : '#fff' }}>{d.label}</h3>
                <span className="text-xs text-gray-500">{d.date}</span>
              </div>
              <div className="space-y-2">
                {agenda.filter((g) => g.day === d.ymd).map((g) => <AgendaCard key={g.key} g={g} today={today} onDecide={decide} />)}
                {d.items.filter((x) => !onlyLive || x.status === 'live').map((it) => (
                  <Task key={`${it.robot.id}-${it.time}-${it.text}`} it={it} dim={d.i < 0 || (d.today && !it.always && it.slot < now)} />
                ))}
              </div>
            </section>
          ))}
        </div>

        {later.length > 0 && (
          <div className="mt-2">
            <h3 className="text-sm font-bold text-white mb-2">Mais adiante</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
              {later.map((g) => (
                <div key={g.key}>
                  <div className="text-[11px] text-gray-500 mb-1">{`${g.day.slice(8, 10)}/${g.day.slice(5, 7)}`}</div>
                  <AgendaCard g={g} today={today} onDecide={decide} />
                </div>
              ))}
            </div>
          </div>
        )}

        {data && (
          <Section title="Pedidos abertos" sub="Pedidos pagos que ainda não foram protocolados. O Ivo lembra o cliente e avisa a equipe quando fica pronto.">
            {!data.orders.length && <p className="text-sm text-gray-400">Nenhum pedido aberto.</p>}
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
              {data.orders.map((o) => (
                <div key={o.ref} className="rounded-2xl border border-white/10 bg-white/[0.04] p-4">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-white truncate">{o.mark || o.ref}</span>
                    {o.test && <span className="text-[10px] font-bold rounded px-1 py-0.5 bg-white/10 text-gray-300">TESTE</span>}
                    <span className="ml-auto text-xs text-gray-400 whitespace-nowrap">{o.days === 0 ? 'pago hoje' : `há ${plural(o.days, ['dia', 'dias'])}`}</span>
                  </div>
                  <div className="text-xs text-gray-500 mt-0.5">{o.ref}{o.client ? ` · ${o.client}` : ''}</div>
                  {o.ready
                    ? <div className="mt-2 text-sm font-semibold text-[#7ee08f]">Pronto para protocolar</div>
                    : <div className="mt-2 flex flex-wrap gap-1.5">{o.missing.map((m) => <span key={m} className="text-[11px] rounded-full px-2 py-0.5 bg-[#e8c547]/15 text-[#f1d36b]">falta {m}</span>)}</div>}
                </div>
              ))}
            </div>
            <a href={data.links.ops} target="_blank" rel="noreferrer" className="inline-block mt-3 text-xs font-semibold text-[#7ee08f]">Abrir o painel da equipe →</a>
          </Section>
        )}

        {data && data.finance && (
          <Section title="Financeiro" sub="Robô Cris: o que os clientes pagaram (US$, pelo Stripe) e as taxas pagas ao INPI (R$). Pedidos de teste ficam de fora.">
            <div className="rounded-2xl border border-white/10 overflow-x-auto">
              <table className="w-full text-[13px] text-gray-200">
                <thead><tr className="text-left text-gray-400"><th className="px-4 py-2 font-semibold">Mês</th><th className="px-4 py-2 font-semibold">Pedidos</th><th className="px-4 py-2 font-semibold">Recebido</th><th className="px-4 py-2 font-semibold">GRUs pagas</th><th className="px-4 py-2 font-semibold">Taxas</th></tr></thead>
                <tbody>
                  {data.finance.months.map((m) => (
                    <tr key={m.month} className="border-t border-white/5">
                      <td className="px-4 py-2">{`${m.month.slice(5, 7)}/${m.month.slice(0, 4)}`}</td>
                      <td className="px-4 py-2">{m.orders}</td>
                      <td className="px-4 py-2">US$ {m.rev_usd.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                      <td className="px-4 py-2">{m.grus}</td>
                      <td className="px-4 py-2">R$ {m.fees_brl.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                    </tr>
                  ))}
                  {!data.finance.months.length && <tr><td className="px-4 py-3 text-gray-400" colSpan={5}>Nenhum movimento ainda.</td></tr>}
                </tbody>
              </table>
            </div>
            {data.finance.gru_pending.length > 0 && <p className="text-xs text-[#f1d36b] mt-2">GRUs a pagar: {data.finance.gru_pending.map((g) => `${g.mark} R$ ${g.value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}${g.test ? ' (teste)' : ''}`).join(' · ')}</p>}
            {data.finance.nf_pending.length > 0 && <p className="text-xs text-gray-400 mt-1">Notas fiscais a emitir: {data.finance.nf_pending.map((n) => `${n.mark} (${n.os})${n.test ? ' teste' : ''}`).join(' · ')}</p>}
          </Section>
        )}

        {data && (
          <Section title="Prospecção" sub="E-mails sniper aprovados por você e agendados para sair às 9h, um a cada 30 segundos.">
            <div className="flex flex-wrap gap-3">
              {data.scheduled.map((s) => (
                <div key={s.day} className="rounded-xl border border-white/10 bg-white/[0.04] px-4 py-3">
                  <div className="text-xl font-bold text-white">{s.count}</div>
                  <div className="text-xs text-gray-400">agendados para {s.day.length === 10 ? `${s.day.slice(8, 10)}/${s.day.slice(5, 7)}` : s.day}</div>
                </div>
              ))}
              <div className="rounded-xl border border-white/10 bg-white/[0.04] px-4 py-3">
                <div className="text-xl font-bold text-white">{data.sent7}</div>
                <div className="text-xs text-gray-400">enviados nos últimos 7 dias</div>
              </div>
            </div>
            <a href={data.links.desk} target="_blank" rel="noreferrer" className="inline-block mt-3 text-xs font-semibold text-[#7ee08f]">Abrir o Desk →</a>
          </Section>
        )}

        {data && (
          <Section id="leads" title="Leads do Grok" sub="Empresas estrangeiras chegando ao Brasil ou à América Latina. O Pedro escreve um e-mail sniper para cada uma, e você aprova aqui mesmo ou no calendário. Sem e-mail confirmado, o lead vira pauta do Max no LinkedIn.">
            {!data.leads.length && <p className="text-sm text-gray-400">Nenhum lead nos últimos 21 dias.</p>}
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
              {data.leads.map((l, i) => <LeadCard key={`${l.empresa}-${i}`} l={l} decide={decide} />)}
            </div>
          </Section>
        )}

        {data && (
          <Section title="Atividade recente" sub="Tudo que os robôs registraram, do mais novo para o mais antigo.">
            {!recent.length && <p className="text-sm text-gray-400">Nada registrado ainda.</p>}
            <div className="rounded-2xl border border-white/10 divide-y divide-white/5 overflow-hidden">
              {recent.map((r, i) => (
                <div key={`${r.at}-${i}`} className="flex gap-3 px-4 py-2.5 text-[13px]" style={{ background: 'rgba(255,255,255,0.03)' }}>
                  <span className="shrink-0">{r.ok ? '✅' : '❌'}</span>
                  <span className="shrink-0 w-24 text-gray-400">{when(r.at)}</span>
                  <span className="min-w-0">
                    <span className="font-semibold text-white">{(BY_ID[r.robot] || { name: r.robot }).name}</span>
                    <span className="text-gray-300"> · {r.resumo}</span>
                    {!r.ok && r.motivo && <span className="block text-[12px] text-[#ff9b9b]">{r.motivo}</span>}
                  </span>
                </div>
              ))}
            </div>
            {free.length > 0 && <p className="text-[11px] text-gray-500 mt-2">{plural(free.length, ['rodada fora da agenda', 'rodadas fora da agenda'])} (testes ou disparos manuais).</p>}
          </Section>
        )}

        <Section title="A equipe de robôs" sub="Cada um tem uma função só. Tudo que sai em nome da TM RUSH para fora passa por você, menos o que você já liberou (acesso, procuração e lembretes do cliente).">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
            {ROBOTS.map((r) => {
              const st = statusOf(r, null, data);
              const lr = lastRun(r.id);
              return (
                <div key={r.id} className="rounded-2xl border border-white/10 p-4" style={{ background: 'rgba(255,255,255,0.04)' }}>
                  <div className="flex items-center gap-3 mb-2">
                    <span className="w-9 h-9 rounded-full flex items-center justify-center text-sm font-bold text-[#0e1513]" style={{ background: r.color }}>{r.name.replace('Grok · ', '').charAt(0)}</span>
                    <div className="min-w-0">
                      <div className="font-semibold text-white">{r.name}{r.grok && <GrokTag />}</div>
                      <div className="text-xs text-gray-400">{r.area} · {r.when}</div>
                    </div>
                    <span className={`ml-auto shrink-0 whitespace-nowrap text-[11px] font-semibold rounded-full px-2 py-0.5 ${STATUS_TONE[st]}`}>{STATUS_LABEL[st]}</span>
                  </div>
                  <p className="text-sm text-gray-200 leading-snug mb-2">{r.what}</p>
                  <p className="text-xs text-gray-400"><span className="text-gray-300 font-semibold">Você:</span> {r.you}</p>
                  {lr && <p className="text-xs text-gray-400 mt-1.5">{lr.ok ? '✅' : '❌'} última: {when(lr.at)} · {lr.resumo}</p>}
                </div>
              );
            })}
          </div>
        </Section>
      </div>
    </main>
  );
};

export default CommandPage;
